module.exports = "/images/vendor/vue-paycard/src/uatp.png?a28af3b425be881a5b9db1da616d3654";